import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './CustomToastStyles.css';
import useAuth from './useAuth';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';
import pdficon from "./pdf.png";


function Edit_Fuel_form() {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const API_BASE_URL1 = process.env.REACT_APP_API_BASE_URL1;
    const token = localStorage.getItem('authToken');
    const navigate = useNavigate();
    const [vehicleModals, setVehicleModals] = useState([]);
    const [vehicleTypes, setVehicleTypes] = useState([]);
    const [vehicleNumbers, setVehicleNumbers] = useState([]);
    const [vehicleMakes, setVehicleMakes] = useState([]);
    const [fuelTypes, setFuelTypes] = useState([]);
    const [error, setError] = useState('');
    const [RptMgrName, setRptMgrName] = useState('');
    const [AdtMgrName, setAdtMgrName] = useState('');
    const [ActMgrName, setActMgrName] = useState('');
    const [EmpCode, setEmpCode] = useState('');
    const [uploadError, setUploadError] = useState("");
    const [Grade, setGrade] = useState('');
    const [loading, setLoading] = useState(true);
    const [responseMessage, setResponseMessage] = useState('');
    const [fuelImages, setImgRows] = useState('');
    const [fuelContentsImages, setFuelContentsImages] = useState('');
    const [flashAlert, setFlashAlert] = useState(null);
    const [flashAlert1, setFlashAlert1] = useState(null);
    const [flashAlert2, setFlashAlert2] = useState(null);
    const { id } = useParams();
    const Loader = () => (
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
            </div>
            <p>Loading...</p>
        </div>
    );
    const [formData, setFormData] = useState({
        comp_name: '',
        emp_code: '',
        grade: '',
        dept_name: '',
        designation_name: '',
        report_mngr: '',
        mode_of_travel: '',
        to_city: '',
        guesthouse: '',
        bank_acnum: '',
        bank_name: '',
        ifsc_code: '',
        total_fuel_amt: '',
        total_fuel_qty: '',
        total_fixed: '',
        img: []  // To store the image files
    });

    //fetch fuel form data
    const fetchFuelFormData = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}getFuelFormById/${id}`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();

            if (result.status && result.data) {
                const fuelForm = result.data;
                const fuelRows = result.fuelFormContents;
                const fuelImages = result.fuelFormImages;
                const fuelContentsImages = result.fuelFormContentsImages;
                setRptMgrName(result.reportManagerName.comp_name || '');
                setAdtMgrName(result.auditManagerName.comp_name || '');
                setActMgrName(result.accountsManagerName.comp_name || '');

                setFormData({
                    id: fuelForm.id || '',
                    emp_code: fuelForm.emp_code || '',
                    comp_name: fuelForm.comp_name || '',
                    mobile: fuelForm.mobile || '',
                    dated: fuelForm.dated || '',
                    bank_acnum: fuelForm.bank_acnum || '',
                    bank_name: fuelForm.bank_name || '',
                    ifsc_code: fuelForm.ifsc_code || '',
                    location_name: fuelForm.location_name || '',
                    grade: fuelForm.grade || '',
                    dept_name: fuelForm.dept_name || '',
                    designation_name: fuelForm.designation_name || '',
                    report_mngr: fuelForm.report_mngr || '',
                    isSubmited: fuelForm.isSubmited || 'NO',
                    total_fuel_qty: fuelForm.total_fuel_qty || '0',
                    total_fuel_amt: fuelForm.total_fuel_amt || '0',
                    total_fixed: fuelForm.total_fixed || '0',
                    audit_status: fuelForm.audit_status || '',
                    audit_remarks: fuelForm.audit_remarks || '',
                    audit_approved_amount: fuelForm.audit_approved_amount || '',
                    audit_mngr: fuelForm.audit_mngr || '',
                    account_mngr: fuelForm.account_mngr || '',
                    rpt_mgr_status: fuelForm.rpt_mgr_status || '',
                    manager_remarks: fuelForm.manager_remarks || '',
                    createdDTM: fuelForm.createdDTM || '',
                    account_status: fuelForm.account_status || '',
                    createdBy: fuelForm.createdBy || '',
                    manager_approved_date: fuelForm.manager_approved_date || '',
                    audit_approved_date: fuelForm.audit_approved_date || '',
                    account_approved_date: fuelForm.account_approved_date || '',
                    account_remarks: fuelForm.account_remarks || '',
                    utr: fuelForm.utr || '',
                    utr_date: fuelForm.utr_date || '',
                });

                if (fuelRows && fuelRows.length > 0) {
                    setTransportRows(fuelRows);
                    console.log("Fuel Rows:", fuelRows);
                }

                if (fuelImages && fuelImages.length > 0) {
                    setImgRows(fuelImages);
                }

                if (fuelContentsImages && fuelContentsImages.length > 0) {
                    setFuelContentsImages(fuelContentsImages);
                }

            } else {
                setError(result.message || 'Failed to fetch form data');
            }
        } catch (error) {
            console.error('Fetch error:', error);
            // setError('Failed to fetch items');
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchFuelFormData();
    }, [id]);



    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitAllowed, setIsSubmitAllowed] = useState(true);
    const [transportRows, setTransportRows] = useState([{
        id: 1,
        dated: '',
        vehicle_number: '',
        vehicle_make: '',
        vehicle_modal: '',
        vehicle_type: '',
        fuel_type: '',
        fuel_unit: '',
        fuel_rate: '',
        fuel_quantity: '',
        fuel_amount: '',
        fixed_amount: '',
        meter_reading: '', receipt: [],
        meter_reading_image: ''
    }]);

    useAuth();  // Custom hook for authentication

    const handleBackClick = () => {
        navigate("/manage_fuel_forms");
    };

    const handleAddTransportRow = () => {
        setTransportRows([
            ...transportRows,
            {
                id: transportRows.length + 1, dated: '', vehicle_number: '',
                vehicle_make: '', vehicle_modal: '', vehicle_type: '', fuel_type: '',
                fuel_unit: '', fuel_rate: '', fuel_quantity: '', fuel_amount: '', fixed_amount: '', meter_reading: '', receipt: [],meter_reading_image: []
            }
        ]);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };


    // fetch vehicle modals
    const fetchVehicleModals = async (id) => {
        try {
            const response = await fetch(`${API_BASE_URL}getVehicleModels`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status) {
                setVehicleModals(result.data);
            } else {
                setError(result.message);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            // setError('Failed to fetch items');
        } finally {
            setLoading(false);
        }
    };

    // fetch vehicle types
    const fetchVehicleTypes = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}getVehicleTypes`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status) {
                setVehicleTypes(result.data);
            } else {
                setError(result.message);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setError('Failed to fetch items');
        } finally {
            setLoading(false);
        }
    };

    // fetch vehicle numbers
    const fetchVehicleNumbers = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}getVehicleNumbers`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status) {
                setVehicleNumbers(result.data);
            } else {
                setError(result.message);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setError('Failed to fetch items');
        } finally {
            setLoading(false);
        }
    };

    // fetch fuel types
    const fetchFuelTypes = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}getFuelTypes`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status) {
                setFuelTypes(result.data);
            } else {
                setError(result.message);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setError('Failed to fetch items');
        } finally {
            setLoading(false);
        }
    };

    // fetch vehicle makes
    const fetchVehicleMakes = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}getVehicleMakes`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status) {
                setVehicleMakes(result.data);
            } else {
                setError(result.message);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setError('Failed to fetch items');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchVehicleTypes();
        fetchVehicleModals();
        fetchVehicleNumbers();
        fetchFuelTypes();
        fetchVehicleMakes();
    }, [navigate]);



    const handleTransportChange = async (index, e) => {
        const { name, value, type, files, id } = e.target;
        const newTransportRows = [...transportRows];
        newTransportRows[index] = { ...newTransportRows[index], [name]: value };


        // Update  
        if (name === 'vehicle_number') {
            // newTransportRows[index].fuel_amount = newTransportRows[index].fuel_rate * newTransportRows[index].fuel_quantity;
            const vehicle = vehicleNumbers.find(vehicle => vehicle.vehicle_number === value);
            if (vehicle) {
                newTransportRows[index].vehicle_modal = vehicle.vehicle_modal;
                newTransportRows[index].vehicle_type = vehicle.vehicle_type;
                newTransportRows[index].fuel_type = vehicle.fuel_type;
                newTransportRows[index].fuel_unit = vehicle.fuel_unit;
            } else {
                newTransportRows[index].vehicle_modal = '';
                newTransportRows[index].vehicle_make = '';
                newTransportRows[index].vehicle_type = '';
                newTransportRows[index].fuel_type = '';
                newTransportRows[index].fuel_unit = '';
            }
        }

        // Update fuel amount when rate or quantity changes (if both are present and quantity is not 0)
        if (name === 'fuel_rate' || name === 'fuel_quantity') {
            // Calculate the fuel amount based on rate and quantity
            const rate = parseFloat(newTransportRows[index].fuel_rate) || 0;
            const quantity = parseFloat(newTransportRows[index].fuel_quantity) || 0;
            newTransportRows[index].fuel_amount = rate * quantity;
            //execute after completing above


        }

        if (parseFloat(newTransportRows[index].fuel_quantity) === 0) {
            // If quantity is 0, fuel_amount can be manually entered
            if (name === 'fuel_amount') {
                newTransportRows[index].fuel_amount = parseFloat(value) || 0;
            } else {
                newTransportRows[index].fuel_amount = '';
            }
        } else {
            // If quantity is not 0, calculate fuel_amount automatically
            const rate = parseFloat(newTransportRows[index].fuel_rate) || 0;
            const quantity = parseFloat(newTransportRows[index].fuel_quantity) || 0;
            newTransportRows[index].fuel_amount = rate * quantity;
        }


        const MAX_SIZE = 1 * 1024 * 1024; // 1MB in bytes

        // If the input type is 'file' and there are selected files
        if (type === 'file' && files.length > 0) {
            const file = files[0]; // Get the first selected file

            try {
                const resizedFile = await resizeImage(file, 1024, 1024, 1); // Resize image to max 1MB

                newTransportRows[index] = { ...newTransportRows[index], [name]: resizedFile };
                setTransportRows(newTransportRows);
            } catch (error) {
                console.error("Error resizing image:", error);
            }
        } else {
            newTransportRows[index] = { ...newTransportRows[index], [name]: value };
        }

        // Update the transport rows state
        setTransportRows(newTransportRows);


    };

    const resizeImage = (file, maxWidth, maxHeight, maxSizeMB) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = (event) => {
                const img = new Image();
                img.src = event.target.result;

                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    let width = img.width;
                    let height = img.height;

                    // Maintain aspect ratio while resizing
                    if (width > maxWidth || height > maxHeight) {
                        if (width > height) {
                            height *= maxWidth / width;
                            width = maxWidth;
                        } else {
                            width *= maxHeight / height;
                            height = maxHeight;
                        }
                    }

                    canvas.width = width;
                    canvas.height = height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, width, height);

                    // Convert canvas to Blob and check size
                    const quality = 0.8; // Adjust quality (0.8 = 80%)
                    canvas.toBlob((blob) => {
                        if (blob.size > maxSizeMB * 1024 * 1024) {
                            reject(new Error("Resized file still exceeds 1MB."));
                        } else {
                            resolve(new File([blob], file.name, { type: file.type }));
                        }
                    }, file.type, quality);
                };
            };

            reader.onerror = (error) => reject(error);
        });
    };






    const handleFileChange = async (e) => {
        const files = Array.from(e.target.files);
        const resizedFiles = [];

        for (const file of files) {
            try {
                const resizedFile = await resizeImage(file, 1024, 1024, 1); // Resize image to max 1MB
                resizedFiles.push(resizedFile);
            } catch (error) {
                console.error("Error resizing image:", error);
            }
        }

        if (resizedFiles.length > 0) {
            setFormData(prevData => ({
                ...prevData,
                img: resizedFiles // Store the resized files
            }));
        }
    };



    const handleRemoveTransportRow = (index) => {
        if (transportRows.length > 1) {
            setTransportRows(transportRows.filter((_, i) => i !== index));
        }
    };





    // Calculate the total amount
    const calculateTotal = () => {
        // Calculate the total amount, make total of all total_fuel_amt rows
        const total_amt = transportRows.reduce((total, row) => total + (parseFloat(row.fuel_amount)), 0);
        //update formData
        setFormData(prevState => ({
            ...prevState,
            total_fuel_amt: total_amt
        }));

    };


    // Calculate the total quantity
    const calculateTotalQuantity = () => {


        const total_qty = transportRows.reduce((total, row) => total + (parseFloat(row.fuel_quantity) || 0), 0);
        //update formData
        setFormData(prevState => ({
            ...prevState,
            total_fuel_qty: total_qty
        }));


    };

    // Calculate the total quantity
    const calculateTotalFixed = () => {


        const total_fixed_amount = transportRows.reduce((total, row) => total + (parseFloat(row.fixed_amount) || 0), 0);
        //update formData
        setFormData(prevState => ({
            ...prevState,
            total_fixed: total_fixed_amount
        }));


    };

    useEffect(() => {
        calculateTotal();
        calculateTotalQuantity();
        calculateTotalFixed();
    }, [transportRows]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!isSubmitAllowed) {
            toast.error("Please fix the file size errors before submitting.");
            return;
        }
        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            const formDataToSend = new FormData();

            // Append regular form fields
            Object.entries(formData).forEach(([key, value]) => {
                if (key === 'img' && Array.isArray(value)) {
                    value.forEach((file, index) => {
                        formDataToSend.append(`img[${index}]`, file);
                    });
                } else {
                    formDataToSend.append(key, value || '');
                }
            });

            // Append transport rows
            transportRows.forEach((row, index) => {
                Object.keys(row).forEach((key) => {
                    if (key === 'receipt' && row[key] instanceof File) {
                        formDataToSend.append(`transportRows[${index}][${key}]`, row[key]);
                    } else {
                        formDataToSend.append(`transportRows[${index}][${key}]`, row[key] || '');
                    }
                });
            });

            transportRows.forEach((row, index) => {
                Object.keys(row).forEach((key) => {
                    if (key === 'meter_reading_image' && row[key]) {
                        formDataToSend.append(`transportRows[${index}][${key}]`, row[key]);
                    } else {
                        formDataToSend.append(`transportRows[${index}][${key}]`, row[key]);
                    }
                });
            });

            const token = localStorage.getItem('authToken');
            const response = await fetch(`${API_BASE_URL}updateFuelForm/${id}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                body: formDataToSend
            });

            const result = await response.json();
            if (response.ok && result.status === 'success') {
                toast.success('Fuel Form submitted successfully!');
                fetchFuelFormData();
                setTimeout(() => {
                    navigate('/edit_fuel_form/' + id);
                }, 2000);
            } else {
                toast.error(result.message || 'An error occurred while submitting the form.');
            }
        } catch (error) {
            console.error('Submission error:', error);
            toast.error('Failed to submit form');
        } finally {
            setIsSubmitting(false);
        }
    };



    const sendForApproval = async () => {
        if (!window.confirm("Are you sure you want to submit this form for approval? Once submitted, you cannot edit the form.")) {
            return; // Exit if user cancels
        }

        try {
            const response = await fetch(`${API_BASE_URL}submitFuelForm/${id}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    formId: formData?.id, // Example form ID, replace with actual data
                    isSubmited: "YES"
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            alert("Form submitted successfully for approval!");
            window.location.reload();
        } catch (error) {
            console.error("Error submitting form:", error);
            alert("An error occurred while submitting the form.");
        }
    };


    return (
        <div className="hold-transition sidebar-mini layout-fixed" style={{ fontSize: '12px' }}>
            <div className="wrapper">
                <Header />
                <Sidebar />
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0" style={{ fontSize: '20px' }}>Edit Fuel Form</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href="/dashboard">Home</a></li>
                                        <li className="breadcrumb-item active">New Fuel Form</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    {loading ? (
                        <Loader /> // Show loader if loading is true
                    ) : (
                        <>
                            <section className="col-lg-12">
                                <div className="card" style={{ borderTop: '3px solid #CC5500' }}>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit} method="post" acceptCharset="utf-8">
                                            <fieldset style={{ border: '1px #ccc solid', padding: '10px' }}>
                                                <div className="box-body">
                                                    <div className="row">

                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Employee No
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="emp_code"
                                                                    id="name"
                                                                    value={formData?.emp_code || ''}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    placeholder="Employee No/Consultant"
                                                                    readOnly
                                                                />

                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Name </label>
                                                                <input
                                                                    type="text"
                                                                    name="comp_name"
                                                                    id="name"
                                                                    value={formData.comp_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    placeholder="Name"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Employee Band</label>
                                                                <input
                                                                    type="text"
                                                                    name="grade"
                                                                    id="name"
                                                                    value={formData.grade}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"

                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Department</label>
                                                                <input
                                                                    type="text"
                                                                    name="dept_name"
                                                                    id="name"
                                                                    value={formData.dept_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"

                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Designation </label>
                                                                <input
                                                                    type="text"
                                                                    name="designation_name"
                                                                    id="name"
                                                                    value={formData.designation_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"

                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Mobile No
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="mobile"
                                                                    id="name"
                                                                    value={formData.mobile}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="bank_name">Bank Name
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="bank_name"
                                                                    id="bank_name"
                                                                    value={formData.bank_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="bank_acnum">Bank Ac.No
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="bank_acnum"
                                                                    id="bank_acnum"
                                                                    value={formData.bank_acnum}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="ifsc_code">IFSC Code
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="ifsc_code"
                                                                    id="ifsc_code"
                                                                    value={formData.ifsc_code}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Reporting Manager
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="report_mngr"
                                                                    id="name"
                                                                    value={formData.report_mngr}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Location
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="report_mngr"
                                                                    id="name"
                                                                    value={formData.location_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>
                                            <fieldset style={{ border: '1px #ccc solid', padding: '10px' }}>
                                                <center>
                                                    <span className="btn btn-warning" style={{ fontSize: '12px', color: 'white', backgroundColor: '#CC5500' }}>
                                                        Details of Fuel Form
                                                    </span>
                                                </center>

                                                <div className="transport-table-container mb-3 text-right">
                                                    <button type="button" onClick={handleAddTransportRow} className="btn btn-sm btn-primary">+</button>

                                                    {/* Responsive Table Wrapper */}
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <td colSpan="12"></td>
                                                                </tr>
                                                                <tr className="header-row text-center">
                                                                    <th>Date<span className="text-danger">*</span></th>
                                                                    <th>Vehicle Number<span className="text-danger">*</span></th>
                                                                    <th>Type</th>
                                                                    <th>Modal</th>
                                                                    <th>Fuel</th>
                                                                    <th>Fuel Unit</th>
                                                                    <th>Fuel Rate<span className="text-danger">*</span></th>
                                                                    <th>Quantity<span className="text-danger">*</span></th>
                                                                    <th>Total</th>
                                                                    <th>Fixed Amount</th>
                                                                    <th>Meter Reading</th>
                                                                    <th>Meter Reading Image</th>
                                                                    <th>Bills Images</th>
                                                                    <th>Actions</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {transportRows.map((row, index) => (
                                                                    <tr key={index}>
                                                                        <td>
                                                                            <input
                                                                                type="date"
                                                                                name="dated"
                                                                                value={row.dated}
                                                                                onChange={(e) => handleTransportChange(index, e)}
                                                                                className="form-control input-font"
                                                                                max={new Date().toISOString().split("T")[0]}
                                                                                required={index === 0}
                                                                            />
                                                                        </td>
                                                                        <td>

                                                                            <input placeholder='Number' list="vm" className='form-control input-font'
                                                                                name='vehicle_number' id='vehicle_number'
                                                                                value={row.vehicle_number}
                                                                                onChange={(e) => handleTransportChange(index, e)} />
                                                                            <datalist id="vm">
                                                                                {vehicleNumbers.map((vehicleNumber) => (
                                                                                    <option key={vehicleNumber.id} value={vehicleNumber.vehicle_number}>
                                                                                        {vehicleNumber.vehicle_number}
                                                                                    </option>
                                                                                ))}
                                                                            </datalist>
                                                                        </td>
                                                                        <td>
                                                                            <input className="form-control input-font"
                                                                                type="text"
                                                                                readOnly
                                                                                value={row.vehicle_type}
                                                                                name="vehicle_type"
                                                                            />

                                                                        </td>

                                                                        <td>
                                                                            <input className="form-control input-font"
                                                                                type="text"
                                                                                readOnly
                                                                                value={row.vehicle_modal}
                                                                                name='vehicle_modal' id='vehicle_modal'
                                                                            />

                                                                        </td>
                                                                        <td>
                                                                            <select readOnly onChange={(e) => handleTransportChange(index, e)}
                                                                                className="form-control input-font"
                                                                                name='fuel_type' id='fuel_type'>
                                                                                {row.fuel_type
                                                                                    ? <option value={row.fuel_type}>{row.fuel_type}</option>
                                                                                    : <option value="">Fuel Type</option>
                                                                                }

                                                                                {fuelTypes.map((fuelType) => (
                                                                                    <option key={fuelType.id} value={fuelType.fuel_type}>
                                                                                        {fuelType.fuel_type}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        </td>
                                                                        <td>
                                                                            <input className="form-control input-font"
                                                                                type="text"
                                                                                readOnly
                                                                                value={row.fuel_unit}
                                                                                name='fuel_unit' id='fuel_unit'
                                                                                required={index === 0}
                                                                            />

                                                                        </td>
                                                                        <td> <input className="form-control input-font"
                                                                            type="number"
                                                                            value={row.fuel_rate}
                                                                            name="fuel_rate"
                                                                            onChange={(e) => handleTransportChange(index, e)}
                                                                        />
                                                                        </td>
                                                                        <td>

                                                                            <input className="form-control input-font"
                                                                                type="number"
                                                                                value={row.fuel_quantity}
                                                                                name="fuel_quantity"
                                                                                onChange={(e) => { handleTransportChange(index, e) }}
                                                                                required={index === 0}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <input
                                                                                className="form-control input-font"
                                                                                type="number"
                                                                                value={row.fuel_amount}
                                                                                name="fuel_amount"
                                                                                onChange={(e) => handleTransportChange(index, e)}

                                                                            />

                                                                        </td>
                                                                        <td style={{ minWidth: '4rem' }}>
                                                                            <input className="form-control input-font"
                                                                                type="number"
                                                                                value={Math.trunc(row.fixed_amount)}
                                                                                name="fixed_amount"
                                                                                onChange={(e) => { handleTransportChange(index, e) }}
                                                                                required={index === 0}
                                                                            />
                                                                        </td>
                                                                        <td style={{ minWidth: '8rem' }}>
                                                                            <input className="form-control input-font"
                                                                                type="number"
                                                                                value={Math.trunc(row.meter_reading)}
                                                                                name="meter_reading"
                                                                                onChange={(e) => { handleTransportChange(index, e) }}
                                                                                required={index === 0}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            {fuelContentsImages && fuelContentsImages.length > 0 ? (
                                                                                fuelContentsImages
                                                                                    .filter((i) => i.fuel_form_content_id === row.id) // Filter images by fuel_form_content_id
                                                                                    .map((i) => {
                                                                                        const imageUrl = `${API_BASE_URL1}assets/uploads/${i.meter_reading_image}`;

                                                                                        // Check if meter_reading_image exists and is a valid string
                                                                                        if (!i.meter_reading_image || typeof i.meter_reading_image !== 'string') {
                                                                                            return null; // Skip rendering if there's no image
                                                                                        }

                                                                                        return (
                                                                                            <div key={i.id} style={{ margin: '5px', display: 'inline-block' }}>
                                                                                                <a href={imageUrl} target="_blank" rel="noopener noreferrer">
                                                                                                    {i.meter_reading_image.toLowerCase().endsWith('.pdf') ? (
                                                                                                        <img
                                                                                                            src={pdficon}
                                                                                                            alt="PDF document"
                                                                                                            style={{
                                                                                                                width: '20px',
                                                                                                                height: '20px',
                                                                                                                objectFit: 'cover'
                                                                                                            }}
                                                                                                        />
                                                                                                    ) : (
                                                                                                        <img
                                                                                                            src={imageUrl}
                                                                                                            alt="Meter Reading"
                                                                                                            style={{
                                                                                                                width: '20px',
                                                                                                                height: '20px',
                                                                                                                objectFit: 'cover'
                                                                                                            }}
                                                                                                            onError={(e) => {
                                                                                                                e.target.style.display = "none"; // Hide broken image
                                                                                                            }}
                                                                                                        />
                                                                                                    )}
                                                                                                </a>
                                                                                            </div>
                                                                                        );
                                                                                    })
                                                                            ) : (
                                                                                <div>No documents available.</div>
                                                                            )}


                                                                            <input
                                                                                type="file"
                                                                                name="meter_reading_image"
                                                                                id="meter_reading_image"
                                                                                accept=".jpg,.jpeg,.png,.pdf"
                                                                                onChange={(e) => handleTransportChange(index, e)}
                                                                                className="form-control input-font"
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            {fuelContentsImages && fuelContentsImages.length > 0 ? (
                                                                                fuelContentsImages
                                                                                    .filter((i) => i.fuel_form_content_id === row.id) // Filter images by fuel_form_content_id
                                                                                    .map((i) => {
                                                                                        const imageUrl = `${API_BASE_URL1}assets/uploads/${i.img}`;

                                                                                        // Check if meter_reading_image exists and is a valid string
                                                                                        if (!i.img || typeof i.img !== 'string') {
                                                                                            return null; // Skip rendering if there's no image
                                                                                        }
                                                                                        return (
                                                                                            <div key={i.id} style={{ margin: '5px', display: 'inline-block' }}>
                                                                                                <a href={imageUrl} target="_blank" rel="noopener noreferrer">
                                                                                                    {i.img && typeof i.img === 'string' && i.img.toLowerCase().endsWith('.pdf') ? (
                                                                                                        <img
                                                                                                            src={pdficon}
                                                                                                            alt="PDF document"
                                                                                                            style={{
                                                                                                                width: '20px',
                                                                                                                height: '20px',
                                                                                                                objectFit: 'cover'
                                                                                                            }}
                                                                                                        />
                                                                                                    ) : (
                                                                                                        <img
                                                                                                            src={imageUrl}
                                                                                                            alt="Document"
                                                                                                            style={{
                                                                                                                width: '20px',
                                                                                                                height: '20px',
                                                                                                                objectFit: 'cover'
                                                                                                            }}
                                                                                                        />
                                                                                                    )}
                                                                                                </a>
                                                                                            </div>
                                                                                        );
                                                                                    })
                                                                            ) : (
                                                                                <div>No documents available.</div>
                                                                            )}


                                                                            <input
                                                                                type="file"
                                                                                name="receipt"
                                                                                id="receipt"
                                                                                accept=".jpg,.jpeg,.png,.pdf"
                                                                                onChange={(e) => handleTransportChange(index, e)}
                                                                                className="form-control input-font"
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <button type="button" onClick={() => handleRemoveTransportRow(index)} className="btn btn-sm btn-danger">×</button>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                            <tfoot>
                                                                <tr>
                                                                    <td colSpan="8"><b>Total Fuel Qty: {formData.total_fuel_qty}</b></td>
                                                                    <td colSpan="1" className="text-right font-weight-bold">
                                                                        Total Amount : ₹ {formData.total_fuel_amt} </td>
                                                                    <td className="text-right font-weight-bold">
                                                                        Total Fixed Amt : ₹ {formData.total_fixed} </td>
                                                                </tr>
                                                            </tfoot>
                                                        </table>
                                                    </div>
                                                </div>
                                            </fieldset>
                                            <fieldset style={{ border: '1px #ccc solid', padding: '10px' }}>
                                                <center>
                                                    <span className="btn btn-primary" style={{ fontSize: '12px', color: 'white', backgroundColor: '#CC5500' }}>
                                                        Additional Documents
                                                    </span>
                                                </center>
                                                <div className="document-table-container" style={{ marginBottom: '20px', textAlign: 'right' }}>
                                                    <table className="document-table" style={{ marginTop: '10px' }}>
                                                        <thead>
                                                            <tr>
                                                                <th style={{ textAlign: 'center' }}>Click to Preview</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {/* Loop through fuelImages and display each document's image */}
                                                            {fuelImages.length > 0 ? (
                                                                <tr>
                                                                    <td colSpan="1" style={{ textAlign: 'center' }}>
                                                                        <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
                                                                            {fuelImages.map((document) => {
                                                                                // Construct the image URL outside the JSX expression
                                                                                const imageUrl = `${API_BASE_URL1}assets/uploads/${document.img}`;

                                                                                return (
                                                                                    <div key={document.id} style={{ margin: '10px' }}>
                                                                                        <a href={imageUrl} target="_blank" rel="noopener noreferrer" className="position-relative">

                                                                                            {document.img && typeof document.img === 'string' && document.img.toLowerCase().endsWith('.pdf') ? (
                                                                                                // If the document is a PDF, show the PDF icon
                                                                                                <img
                                                                                                    src={pdficon} // Replace with the actual path to your PDF icon
                                                                                                    alt={`PDF Document ${document.id}`}
                                                                                                    style={{
                                                                                                        width: '100px',
                                                                                                        height: '100px',
                                                                                                        objectFit: 'cover',
                                                                                                        margin: '5px',
                                                                                                    }}
                                                                                                />
                                                                                            ) : (
                                                                                                // Otherwise, show the image
                                                                                                <img
                                                                                                    src={imageUrl}
                                                                                                    alt={`Document ${document.id}`}
                                                                                                    style={{
                                                                                                        width: '79px',
                                                                                                        height: '100px',
                                                                                                        objectFit: 'cover',
                                                                                                        margin: '5px',
                                                                                                    }}
                                                                                                />
                                                                                            )}
                                                                                        </a>
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="1" style={{ textAlign: 'center' }}>
                                                                        {error ? error : 'No documents available.'}
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </fieldset>


                                            {/* Uplosad Images Section */}
                                            <section className="col-lg-12">
                                                {uploadError && <div className="alert alert-danger text-center p-2">{uploadError}</div>}

                                                <label className="font-weight-bold">Upload Multiple Images:</label>
                                                <input
                                                    type="file"
                                                    name="img"
                                                    multiple
                                                    accept=".jpg,.jpeg,.png,.pdf"
                                                    onChange={handleFileChange}
                                                    className="form-control mb-3"
                                                />


                                                {/* Reporting Manager Section */}
                                                <div className="row mt-3">
                                                    {/* Reporting Manager Status */}
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="rpt_mgr_status" className="form-label" style={{ fontSize: '12px' }}>
                                                                Reporting Manager Status
                                                            </label>
                                                            <select
                                                                name="rpt_mgr_status"
                                                                id="rpt_mgr_status"
                                                                value={formData.rpt_mgr_status || ''}
                                                                onChange={handleChange}
                                                                className="form-control custom-select"
                                                                required
                                                                disabled
                                                            >
                                                                <option value="Pending">Pending</option>
                                                                <option value="Approved">Approved</option>
                                                                <option value="Rejected">Rejected</option>
                                                            </select>

                                                        </div>
                                                    </div>

                                                    {/* Reporting Manager Remarks */}
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="remarks" className="form-label" style={{ fontSize: '12px' }}>
                                                                Reporting Manager Remarks
                                                            </label>
                                                            <textarea
                                                                name="manager_remarks"
                                                                id="remarks"
                                                                value={formData.manager_remarks || ''}
                                                                onChange={handleChange}
                                                                className="form-control"
                                                                required
                                                                disabled
                                                            ></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="audit_status">Audit Status

                                                            </label>
                                                            <select
                                                                name="audit_status"
                                                                id="audit_status"
                                                                value={formData.audit_status}
                                                                onChange={handleChange}
                                                                disabled
                                                                className="form-control input-font custom-select"

                                                            >

                                                                <option value="Pending">Pending</option>
                                                                <option value="Approved">Approved</option>
                                                                <option value="Rejected">Rejected</option>
                                                            </select>

                                                        </div>
                                                    </div><div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="name">
                                                                Audit Approved Amount

                                                            </label>
                                                            <input
                                                                type="text"  // Keep the type as text
                                                                name="audit_approved_amount"
                                                                id="name"
                                                                value={formData.audit_approved_amount !== '' ? Math.floor(formData.audit_approved_amount) : ''}
                                                                onChange={handleChange}
                                                                onInput={(e) => {
                                                                    // Allow only numeric input (no decimal, no special characters)
                                                                    const inputValue = e.target.value;
                                                                    if (/[^0-9]/.test(inputValue)) {
                                                                        // If non-numeric character is found, remove it
                                                                        e.target.value = inputValue.replace(/[^0-9]/g, '');
                                                                    }
                                                                }}
                                                                className="form-control input-font"
                                                                required
                                                                disabled
                                                            />
                                                        </div>

                                                    </div>

                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="audit_remarks">Audit Remarks

                                                            </label>

                                                            <textarea
                                                                id="audit_remarks"
                                                                name="audit_remarks"
                                                                value={formData.audit_remarks}
                                                                onChange={handleChange}
                                                                className="form-control"
                                                                required
                                                                rows='1'
                                                                disabled
                                                            ></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label style={{ fontSize: '12px' }} htmlFor="account_status">Finance Manager Status

                                                            </label>
                                                            <select
                                                                name="account_status"
                                                                id="account_status"
                                                                value={formData.account_status || ''}
                                                                onChange={handleChange}
                                                                className="form-control input-font"
                                                                required
                                                                disabled
                                                            >
                                                                <option value="Pending">Pending</option>
                                                                <option value="Approved">Approved</option>

                                                            </select>

                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label style={{ fontSize: '12px' }} htmlFor="account_remarks">Finance Manager Remarks

                                                            </label>

                                                            <textarea name="account_remarks"
                                                                required
                                                                id="remarks"
                                                                value={formData.account_remarks || ''}
                                                                onChange={handleChange}
                                                                className="form-control "
                                                                disabled

                                                            ></textarea>

                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='row'>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="name">UTR

                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="utr"
                                                                id="name"
                                                                value={formData.utr}
                                                                disabled
                                                                onChange={handleChange}
                                                                className="form-control input-font"
                                                                placeholder="utr"


                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="name">date

                                                            </label>
                                                            <input
                                                                type="date"
                                                                name="utr_date"
                                                                id="utr_date"
                                                                value={formData.utr_date}
                                                                disabled
                                                                onChange={handleChange}
                                                                className="form-control input-font"
                                                                placeholder="utr date"


                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Buttons */}
                                                <div className="d-flex justify-content-center">
                                                    {formData?.isSubmited === 'NO' && (<button type="submit" className="btn btn-warning">
                                                        {isSubmitting ? 'Saving Changes...' : 'Save As Drafts'}
                                                    </button>)}
                                                    <button type="button" className="btn btn-secondary ml-3" onClick={handleBackClick}>
                                                        Cancel
                                                    </button>

                                                </div>
                                            </section>

                                        </form>
                                        <div className="d-flex justify-content-center mt-3">
                                            {formData?.isSubmited === 'NO' && (<button onClick={sendForApproval} className='btn btn-success ml-3'>Send for Approval</button>)}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 row" style={{ width: '100%' }}>
                                    <div style={{ border: '#cccccc 1px solid' }} className="col-sm-3">
                                        <b>Prepared by </b>
                                        <p> {formData.emp_code} ({formData.comp_name})<br /> Date
                                            : {formData.createdDTM}
                                        </p>
                                    </div>
                                    <div style={{ border: '#cccccc 1px solid' }} className="col-sm-3">
                                        {formData.rpt_mgr_status === 'Approved' && (
                                            <>
                                                <b> Approved by</b>
                                                <p> {formData.report_mngr} ({RptMgrName})<br /> Date
                                                    : {formData.manager_approved_date}
                                                </p>
                                            </>
                                        )}
                                    </div>
                                    <div style={{ border: '#cccccc 1px solid' }} className="col-sm-3">
                                        {formData.audit_status === 'Approved' && (
                                            <>
                                                <b> Verified by Audit Team</b>
                                                <p>                         <span>
                                                    {formData.audit_mngr} ({AdtMgrName})<br /> Date
                                                    : {formData.audit_approved_date}
                                                </span>
                                                </p>
                                            </>
                                        )}
                                    </div>
                                    <div style={{ border: '#cccccc 1px solid' }} className="col-sm-3">
                                        {formData.account_status === 'Approved' && (
                                            <>
                                                <b> Verified by Finance Team</b>
                                                <p>                         <span>
                                                    {formData.account_mngr} ({ActMgrName})<br /> Date
                                                    : {formData.account_approved_date}
                                                </span>
                                                </p>
                                            </>
                                        )}
                                    </div>



                                </div>
                            </section>
                        </>
                    )}
                </div>
                <Footer />
            </div>
            <ToastContainer />
        </div>
    )
}

export default Edit_Fuel_form